// extracted by mini-css-extract-plugin
module.exports = {"container":"Admin_container__3KZEs","title":"Admin_title__mKSeS","lowertitle":"Admin_lowertitle__3rA3-"};